"use client";

import clsx from "clsx";
import {useTranslation} from "react-i18next";
import Icon from "@/components/library/Icon";

export const selectionLabelKey = (approved: boolean) => approved ? "toolApproval.selectedApproval" : "toolApproval.selectedRejection";

export function selectionClass(queued?: boolean | null) {
   if (queued === true) return "approval-selected-approval border-green-400/60 bg-green-50/40 dark:bg-green-950/20";
   if (queued === false) return "approval-selected-rejection border-amber-400/60 bg-amber-50/40 dark:bg-amber-950/20";
   return undefined;
}

function statusClass(queued: boolean | null | undefined, saved: boolean, statusKey: string) {
   if (queued === true) return "bg-100 text-600";
   if (queued === false) return "bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-200";
   if (saved) return "text-green-700 dark:text-green-300";
   if (statusKey.endsWith(".required")) return "bg-amber-50 text-amber-800 dark:bg-amber-950/60 dark:text-amber-200";
   return "text-500";
}

/** A local selection is never a receipt confirming that the change was saved. */
export default function ApprovalDecisionStatus({queued, statusKey, saved = false}: {
   queued?: boolean | null;
   statusKey: string;
   saved?: boolean;
}) {
   const {t} = useTranslation("ask");
   return <output className={clsx("inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-xs font-medium", statusClass(queued, saved, statusKey))}>
      {(queued != null || saved) && <Icon icon={queued === false ? "xmark" : "check"} className="h-3 w-3" />}
      {t(queued != null ? selectionLabelKey(queued) : statusKey)}
   </output>;
}
